import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchAccessShortcutAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_access_shortcut_add"}/>
}
